import React, {FunctionComponent, useContext} from "react";
import {User} from '/src/domain/shared/User';
import {ChallengeProtocolData} from "/src/domain/challenges/ChallengeProtocolData";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Link,
    ButtonBase,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import {useTranslation} from "react-i18next"
import {appealEmail} from "/src/domain/shared/appealEmail";
import {trimName} from "/src/domain/shared/trimName"
import copy from 'copy-to-clipboard';
import {PageContext, PageContextProps} from "/src/contexts/Page";

interface AppealDialogData {
    isDialogOpen: boolean;
    closeDialog: () => void;
    challengeProtocol: ChallengeProtocolData;
    currentUser?: User;
}

const AppealDialog: FunctionComponent<AppealDialogData> = ({
                                                               isDialogOpen,
                                                               closeDialog,
                                                               challengeProtocol,
                                                               currentUser
                                                           }) => {
    const {t} = useTranslation()
    const classes = useStyles()
    const {pageConfig} = useContext(PageContext) as PageContextProps;

    const copyData = () => {
        const text = document.getElementsByClassName(classes.challengeData)[0].textContent || ''
        copy(text)
    }

    return (
        <Dialog open={isDialogOpen} onClose={closeDialog}>
            <div className={classes.dialog}>
                <DialogTitle>{t('appeal')}</DialogTitle>
                <DialogContent className={classes.content}>
                    <p>
                        <b>Время приема апелляций:</b> с открытия стартового окна до закрытия стартового окна + одни
                        сутки.
                        Апелляции принимаются только на электронную почту {pageConfig?.appealEmail}
                    </p>
                    <div>
                        <p>
                            <b>Для подачи апелляции обязательно указать:</b>
                        </p>
                        <ul className={classes.list}>
                            <li>свой id в системе S10</li>
                            <li>ссылку на трек в Strava</li>
                            <li>подробное описание проблемы</li>
                            <li>ожидаемый результат</li>
                        </ul>
                    </div>
                    <p>
                        Апелляции без ссылки на id, без ссылки на трек в Strava, без описания проблемы не
                        рассматриваются.
                        Если вы отправляете письмо со страницы протокола, то ваш Id будет вставлен в заголовок письма
                        автоматически.
                    </p>
                    <p>
                        Перед отправкой апелляции имеет смысл прочитать еще раз правила и свериться с чек-листом.
                    </p>
                    <p>
                        Ответы на наиболее частые вопросы можно найти <Link
                        href="https://answers.s10.run/t/pochemu-moj-trek-dsq-diskvalificzirovan-ili-ne-v-protokole/70">здесь</Link>.
                    </p>
                    <p className={classes.challengeData}>
                        {`${trimName(currentUser?.firstName, currentUser?.lastName)} `}<br/>
                        {`#${currentUser?.id} `}<br/>
                        {challengeProtocol.challenge.name}
                        <ButtonBase onClick={copyData} className={classes.copyButton}>
                            <FileCopyIcon/>
                        </ButtonBase>
                    </p>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => appealEmail(challengeProtocol, currentUser, pageConfig?.appealEmail || "")}
                    >
                        {t('sendMessage')}
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    )
}

const useStyles = makeStyles({
    dialog: {
        paddingBottom: '1rem'
    },
    content: {
        '&>p, div': {
            marginBottom: '1rem'
        }
    },
    list: {
        padding: '0.5rem 0 0 1rem'
    },
    challengeData: {
        borderRadius: '5px',
        position: 'relative',
        background: 'rgba(0, 0, 0, 0.1)',
        padding: '0.5rem 2rem 0.5rem 0.75rem'
    },
    copyButton: {
        borderRadius: '5px',
        position: 'absolute',
        right: '0.5rem',
        top: '0.5rem'
    }
})

export default AppealDialog